/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190703 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { AppParameterDaoService } from '../app-parameter-dao.service';
import { AppParameter } from 'src/app/_model/app-parameter';

// CONSTANTS
const APP_PARAMETER_KEY = 'app_parameters';

@Injectable()
export class AppParameterStorageDaoService implements AppParameterDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveAppParameters(appParameter: AppParameter): Promise<void> {
    return this.keyValueStorage.store(APP_PARAMETER_KEY, appParameter);
  }
  public async getAppParameters(): Promise<AppParameter> {
    const obj = await this.keyValueStorage.load(APP_PARAMETER_KEY)
    return new AppParameter(obj);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(APP_PARAMETER_KEY);
  }
}
